import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types for Fetching Coupons
export const FETCH_COUPONS_REQUEST = 'FETCH_COUPONS_REQUEST';
export const FETCH_COUPONS_SUCCESS = 'FETCH_COUPONS_SUCCESS';
export const FETCH_COUPONS_FAILURE = 'FETCH_COUPONS_FAILURE';

// Action Types for Adding Coupons
export const ADD_COUPON_REQUEST = 'ADD_COUPON_REQUEST';
export const ADD_COUPON_SUCCESS = 'ADD_COUPON_SUCCESS';
export const ADD_COUPON_FAILURE = 'ADD_COUPON_FAILURE';

export const UPDATE_COUPON_REQUEST = 'UPDATE_COUPON_REQUEST';
export const UPDATE_COUPON_SUCCESS = 'UPDATE_COUPON_SUCCESS';
export const UPDATE_COUPON_FAILURE = 'UPDATE_COUPON_FAILURE';

export const DELETE_COUPON_REQUEST = 'DELETE_COUPON_REQUEST';
export const DELETE_COUPON_SUCCESS = 'DELETE_COUPON_SUCCESS';
export const DELETE_COUPON_FAILURE = 'DELETE_COUPON_FAILURE';


// Action Creators for Fetching Coupons
export const fetchCouponsRequest = () => ({
  type: FETCH_COUPONS_REQUEST,
});

export const fetchCouponsSuccess = (coupons) => ({
  type: FETCH_COUPONS_SUCCESS,
  payload: coupons,
});

export const fetchCouponsFailure = (error) => ({
  type: FETCH_COUPONS_FAILURE,
  payload: error,
});


// Action Creators for Adding Coupons
export const addCouponRequest = () => ({
  type: ADD_COUPON_REQUEST,
});

export const addCouponSuccess = (coupon) => ({
  type: ADD_COUPON_SUCCESS,
  payload: coupon,
});

export const addCouponFailure = (error) => ({
  type: ADD_COUPON_FAILURE,
  payload: error,
});

export const updateCouponRequest = () => ({
  type: UPDATE_COUPON_REQUEST,
});

export const updateCouponSuccess = (coupon) => ({
  type: UPDATE_COUPON_SUCCESS,
  payload: coupon,
});

export const updateCouponFailure = (error) => ({
  type: UPDATE_COUPON_FAILURE,
  payload: error,
});


export const deleteCouponRequest = () => ({
  type: DELETE_COUPON_REQUEST,
});

export const deleteCouponSuccess = (couponId) => ({
  type: DELETE_COUPON_SUCCESS,
  payload: couponId,
});

export const deleteCouponFailure = (error) => ({
  type: DELETE_COUPON_FAILURE,
  payload: error,
});


// Fetch Coupons Thunk
export const fetchCoupons = () => {
  return async (dispatch) => {
    dispatch(fetchCouponsRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/coupon/getAll`, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });
      const { data, meta } = response.data;
      if (meta?.status) {
        dispatch(fetchCouponsSuccess(data));
      } else {
        dispatch(fetchCouponsFailure(meta?.message || 'Failed to fetch coupons'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.meta?.message || error.message;
      dispatch(fetchCouponsFailure(errorMessage));
    }
  };
};


// Add Coupon Thunk
export const addCoupon = (couponData) => {
  return async (dispatch) => {
    dispatch(addCouponRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      const response = await axios.post(`${BASE_URL}/v1/api/coupon/create`, couponData, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });

      if (response.data.meta?.status) {
        dispatch(addCouponSuccess(response.data.data));
      } else {
        dispatch(addCouponFailure(response.data.meta?.message || 'Failed to add coupon'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.meta?.message || error.message;
      dispatch(addCouponFailure(errorMessage));
    }
  };
};




// updateCoupon action
export const updateCoupon = (couponId, couponData) => {
  return async (dispatch) => {
    dispatch(updateCouponRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      const response = await axios.put(
        `${BASE_URL}/v1/api/coupon/update/${couponId}`,
        couponData,
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );

      if (response.data.meta?.status) {
        dispatch(updateCouponSuccess(response.data.data));
      } else {
        dispatch(updateCouponFailure(response.data.meta?.message || 'Failed to update coupon'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.meta?.message || error.message;
      dispatch(updateCouponFailure(errorMessage));
    }
  };
};


export const deleteCoupon = (couponId) => {
  return async (dispatch) => {
    dispatch(deleteCouponRequest());

    const token = localStorage.getItem('token');  // Get token from localStorage

    try {
      const response = await axios.delete(`${BASE_URL}/v1/api/coupon/delete/${couponId}`, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });

      if (response.data.meta?.status) {
        dispatch(deleteCouponSuccess(couponId));
      } else {
        dispatch(deleteCouponFailure(response.data.meta?.message || 'Failed to delete coupon'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.meta?.message || error.message;
      dispatch(deleteCouponFailure(errorMessage));
    }
  };
};